import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Errors, LeaderboardService } from '../../../../core';

@Component({
  selector: 'app-product-booking-accordion',
  templateUrl: './product-booking-accordion.component.html',
  styleUrls: ['./product-booking-accordion.component.scss'],
})
export class ProductBookingAccordionComponent implements OnChanges {
  @Input() prodBookingData: any[] = [];
  @Input() leaderboardType: string = '';
  @Input() userProfile: any;
  @Input() begeoid: any;
  @Input() size: number = 5;

  page: number[] = [];
  pvcRankDetails: any;
  errors: Errors = { errors: {} };

  constructor(private leaderboardService: LeaderboardService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['prodBookingData'] && this.prodBookingData && this.prodBookingData.length > 0) {
      this.page = [];
      this.productBookingChg();
    }
  }

  productBookingChg(): void {
    this.prodBookingData.forEach((element: any, i: number) => {
      element.subcategory = [];
      if (i == 0) {
        element.accordianState = true;
        this.getProductBookingList(0, this.prodBookingData[0].id);
        this.getActivityLeaderboardRankDetails(element.loggedUserChallengeId);
      } else {
        element.accordianState = false;
      }
    });
  }

  openAccordian(i: number): void {
    this.prodBookingData[i].subcategory = [];
    this.prodBookingData.forEach((element: any, index: number) => {
      if (i === index) {
        element.accordianState = true;
        this.getActivityLeaderboardRankDetails(element.loggedUserChallengeId);
      } else {
        element.accordianState = false;
      }
    });
  }

  closeAccordian(i: number): void {
    this.prodBookingData.forEach((ele: any, ind: number) => {
      if (i === ind) {
        ele.accordianState = false;
      }
    });
    this.prodBookingData[i].subcategory = [];
  }

  getProductBookingList(index: number, id: any, event?: any): void {
    this.page[index] = event ? event : 1;
    const pathParams = {
      type: this.leaderboardType,
      challengeId: id,
      companyId:
        this.userProfile &&
        this.userProfile.hasOwnProperty('userType') &&
        this.userProfile.userType == 'PAM'
          ? this.userProfile.company.id
          : '',
    };
    const queryParams = {
      page: this.page[index] - 1,
      size: this.size,
    };
    this.leaderboardService.getMoreChallenges(pathParams, queryParams).subscribe((res) => {
      if (event) {
        this.prodBookingData[index].entries.content = [];
        this.prodBookingData[index].entries.content = res.content;
      } else {
        this.prodBookingData[index].entries = res;
      }
    });
  }

  getactivityLeaderboardSubcategoryData(id: any, i: number, chalgId: any): void {
    const req = id + '?companyId=' + this.userProfile.company.id;
    this.leaderboardService.getActivityLeaderboardSubCategory(req).subscribe((data) => {
      this.prodBookingData.forEach((element: any) => {
        if (element.id == chalgId) {
          element.subcategory = data;
          element.entries.content[i].panelStatus = true;
        }
      });
    });
  }

  closeSubCategory(i: number, id: any, j: number): void {
    this.prodBookingData.forEach((element: any) => {
      if (element.id == id) {
        element.entries.content[j].panelStatus = false;
      }
    });
    this.prodBookingData[i].subcategory = [];
  }

  getActivityLeaderboardRankDetails(id: any): void {
    this.leaderboardService.getActivityLeaderboardRankDetails(id).subscribe(
      (response) => {
        this.pvcRankDetails = response;
      },
      (err) => {
        this.errors = err;
      }
    );
  }

  commaNumberFormate(x: any): string {
    if (x === 0 || x === null) {
      return '0';
    }
    if (x) {
      return parseFloat(x.toString())
        .toFixed(0)
        .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
    }
    return x;
  }
}
